"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _modalLoaderUtils = require("@wsb/modal-loader-utils");
/* eslint-disable no-console */

var snakeToCamel = _modalLoaderUtils.HELPERS.snakeToCamel;

/**
 * @description:
 *
 * getRegisteredAppVersion returns the modal version that a
 * registered, consuming app should be using. If the consuming app
 * is not registered, then the latest, live version of the modal
 * will be returned. The same is true when the version for the app is
 * set to 'latest'.
 *
 * However, we must also consider the case where a version is manually specified
 * via the URL params 'socialShareLiveVersion' and 'contentComposerLiveVersion'.
 * If a version is manually specified, we should override the version that is being
 * returned from appConfig.
 */
var _default = exports.default = function _default(props, appConfig, key) {
  if (!appConfig || !props.appProps || props.appProps && !props.appProps.sourceApp) return '';
  var sourceApp = props.appProps.sourceApp,
    namespace = props.namespace;
  var _appConfig$registered = appConfig.registeredApps,
    registeredApps = _appConfig$registered === void 0 ? {} : _appConfig$registered;
  var camelNs = snakeToCamel(namespace);
  var nsLiveVersion = appConfig[key];
  var registeredAppVersion = registeredApps[sourceApp];
  if (registeredAppVersion) {
    if (!['latest', nsLiveVersion].includes(registeredAppVersion)) {
      console.warn("".concat(sourceApp, " is running an outdated version of ").concat(camelNs, "!"));
      return registeredAppVersion;
    }
  } else {
    console.warn("".concat(camelNs, " does not have the app '").concat(sourceApp, "' listed as a registered app! ") + 'Please see README to register your application.');
  }
  return nsLiveVersion;
};